<template>
	<!-- modal Verify Email start -->
	<div :class="modal ? 'modal is-active' : 'modal'">
    <div class="modal-background"></div>
    <div class="modal-card is-small">
      <header class="modal-card-head">
        <button @click="closeModal()" class="delete" aria-label="close"></button>
        <p class="modal-card-title">Verify Email</p>	
      </header>
      <section class="modal-card-body ph20 has-text-centered ">
        <img src="@/assets/img/icon-email.svg" alt="email" class="mb20 mt20">
        <p class="is-size-14 mb30">Your email has been verified.</p>
      <!-- form end -->
      </section>
      <footer class="modal-card-foot">
        <button @click="closeModal()" class="button is-large is-transparent is-full-width">Okay</button>
      </footer>
    </div>
	</div>
	<!-- modal Verify Email end -->
</template>

<script>
export default {
  data() {
    return {
      modal: false,
    };
  },
  mounted() {
    bus.$on('show-modal-verified-email', (payload) => {
      this.modal = payload;
    })
  },
  
  beforeDestroy() {
    bus.$off('show-modal-verified-email');
  },

  methods: {
    closeModal() {
      this.modal = false;
    }
  },
};
</script>